import { getMarket, getTags } from './helpers';
import { getTagsByProcess } from './tags';

const replaceGenesysTags = (tags, processTags) => {
    let newTags = [];
    tags.forEach((t) => {
        newTags.push(processTags[t] ?? t);
    });
    return newTags;
};

const getSaleData = (args) => {
    const market = getMarket(args);
    const processTags = getTagsByProcess('Sale');

    let tags = getTags(
        args.tags,
        processTags,
        market,
        args.verMO ? true : false,
        args.loginType ? args.loginType : 'none',
        args.name
    );
    tags = replaceGenesysTags(tags, processTags);

    return {
        tags: tags,
        ...(args.additionalData && {
            ...args.additionalData
        })
    };
};

export default getSaleData;
